<template>
    <ul class="broker blog-list">
        <div v-if="title" class="search-result" v-html="sysTitle"></div>
        <li class="item" v-for="item in list" :key="item.id">
            <a
                :href="item.url"
                :target="detailOpenStyle"
                :aria-label="item.title"
                rel="noopener noreferrer"
            >
                <img-box
                    class="blog-img"
                    :alt="[item.title, item.author].join()"
                    :src="item.previewPicture"
                />

                <p class="blog-title">{{ item.title }}</p>
                <p
                    :style="{
                        visibility: item.previewContent ? 'unset' : 'hidden'
                    }"
                    class="content"
                >{{item.previewContent}}</p>
                <div class="readmore">
                    <p>{{ $t('md-blog-list.readMore') }}</p>
                    <span class="icon">
                        <i class="iconfont icon-arrow-up"></i>
                    </span>
                </div>
            </a>
        </li>
    </ul>
</template>

<script>
import openMixins from '../open.mixin';

export default {
    props: ['list', 'title', 'count'],
    mixins: [openMixins]
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.blog-list.broker {
    &.blog-list {
        .search-result {
            margin-bottom: 40px;
            font-size: 36px;
            line-height: 40px;
            font-family: var(--font-bold);
            .active-text {
                @include color-theme();
            }
        }
        .title {
            font-family: var(--font-bold);
            font-size: 36px;
            line-height: 40px;
            color: var(--color-text);
            margin-bottom: 40px;

            .active-text {
                @include color-theme();
            }
        }

        &:after {
            content: '';
            display: block;
            clear: both;
        }

        .item {
            margin-bottom: 20px;
            width: calc((100% - 20px) / 2);
            margin-right: 20px;
            float: left;
            padding: 15px;
            border-radius: 5px;
            background-color: #f3f3f3;
            cursor: pointer;

            @include media-600 {
                width: 100%;
                margin-bottom: 15px;
                &:last-child {
                    margin-bottom: 5px;
                }
            }
            &:nth-child(2n) {
                margin-right: 0;
            }

            &:hover {
                background-color: #fff;
                box-shadow: 0 2px 10px 0 rgba(0, 10, 30, 0.1);
                .blog-title {
                    color: var(--color-theme);
                    text-decoration: underline;
                }
                .readmore {
                    background: #f3f3f3;
                    .icon {
                        background: var(--color-theme);
                        &:before {
                            content: '';
                            width: 0;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            top: 0;
                            border: 40px solid #f3f3f3;
                            border-right-color: rgba(0, 0, 0, 0);
                            border-bottom-color: rgba(0, 0, 0, 0);
                            border-left-color: rgba(0, 0, 0, 0);
                            transform: translateX(-35px) rotate(-15deg);
                        }
                    }
                }
            }
            .blog-title {
                margin: 20px 0 10px;
                font-size: 16px;
                line-height: 111%;
                font-family: var(--font-title);
                color: var(--color-text);
                @include ellipsis();
                @include media-600 {
                    font-size: 16px;
                }
            }

            .blog-img {
                width: 100%;
                height: 210px;
                object-fit: cover;
            }

            .content {
                font-size: 14px;
                color: #505050;
                margin-bottom: 20px;
                line-height: 21px;
                height: 42px;
                @include webkitBox(2);
            }
            .readmore {
                width: 100%;
                height: 40px;
                line-height: 40px;
                margin-top: 25px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                background: #fff;
                border-radius: 5px;
                padding-left: 15px;
                align-items: center;
                p {
                    font: 14px var(--font-normal);
                    color: #191919;
                }
                .icon {
                    width: 80px;
                    height: 100%;
                    position: relative;
                    background: #101010;
                    overflow: hidden;
                    border-radius: 0 5px 5px 0;
                    text-align: center;
                    &:before {
                        content: '';
                        width: 0;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        border: 40px solid #fff;
                        border-right-color: rgba(0, 0, 0, 0);
                        border-bottom-color: rgba(0, 0, 0, 0);
                        border-left-color: rgba(0, 0, 0, 0);
                        transform: translateX(-35px) rotate(-15deg);
                    }
                    .icon-arrow-up {
                        transform: translateX(10px) rotate(90deg);
                        display: inline-block;
                        color: #fff;
                        font-size: 24px;
                    }
                }
            }
        }
    }
    @include media-600 {
        &.blog-list {
            .item {
                .blog-title {
                    margin-bottom: 10px;
                }
            }
        }
    }
}
</style>
